import React from 'react'

import { WysiwygProps } from './types'
import { WysiwygStyled } from './styles'

const Wysiwyg: React.FC<WysiwygProps> = ({ children, isSmallText }) => {
  return <WysiwygStyled {...{ isSmallText }}>{children}</WysiwygStyled>
}

export default Wysiwyg
